import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MessageList from './MessageList';
import MessengerInput from './MessageInput';
import { selectChatData, selectChatState } from '../../selectors/chat.selector';
import { getLastMessageToken } from '../../../shared/utils/chat-utils';
import { LoadMessages, ReadMessages } from '../../actions/chat.action';
import ChatHeader from './ChatHeader';
import NoChat from './NoChat';
import LoadingOverlay from '../../../shared/components/LoadingOverlay/LoadingOverlay';
import ChatError from './ChatError';

interface ChatViewProps {
  activeChatId?: string;
}

const ChatView = (props: ChatViewProps) => {
  const {
    activeChatId = '',
  } = props;

  const dispatch = useDispatch();
  const chat = useSelector(selectChatData)(activeChatId);
  const chatState = useSelector(selectChatState);
  const messages = chat?.messages;
  const lastSequenceId = chat?.lastSequenceId;

  useEffect(() => {
    // While the initial connect is still in flight, it may already be fetching
    // this chat's messages in bulk - wait for it to settle before fetching
    // individually, so we don't fire a redundant duplicate request.
    if (activeChatId && !chatState?.connecting && !chat?.loading && !chat?.loaded && !chat?.error) {
      dispatch(new LoadMessages(activeChatId));
    }
  }, [activeChatId, chatState?.connecting, chat?.loading, chat?.loaded, chat?.error]);

  useEffect(() => {
    if (messages?.length > 0) {
      localStorage.setItem(getLastMessageToken(activeChatId), `${lastSequenceId}`);
      dispatch(new ReadMessages(activeChatId));
    }
  }, [messages]);

  return activeChatId ? (
    <div className={`chat-view-container ${!activeChatId ? 'hide' : ''}`}>
      <div
        className="chat-view"
        key={activeChatId}
      >
        <ChatHeader activeChatId={activeChatId} />
        {
          !chat?.loaded && !chat?.loading && chat?.error ? (
            <ChatError message={chat.error} onRetry={() => dispatch(new LoadMessages(activeChatId))} />
          ) : null
        }
        {
          !chat?.loading && chat?.loaded ? (
            <MessageList messages={messages} />
          ) : null
        }
        <MessengerInput activeChatId={activeChatId} />
        {
          chat?.loading && !chat?.loaded ? (
            <div className="d-flex h-100">
              <LoadingOverlay />
            </div>
          ) : null
        }
      </div>
    </div>
  ) : (
    <div className={`d-flex flex-grow-1 w-100 ${!activeChatId ? 'hide' : ''}`}>
      <NoChat />
    </div>
  );
};

ChatView.defaultProps = {
  activeChatId: '',
};

export default ChatView;
